// extracted by mini-css-extract-plugin
export var button = "_ny-2";
export var card = "_ny-0";
export var closeButtonContainer = "_ny-3";
export var iconContainer = "_ny-1";